import { ComponentsOverrides, Theme } from "@mui/material";
import { ciCustomColors } from "./colors";

type MuiButton = {
  styleOverrides: ComponentsOverrides<Theme>["MuiButton"];
};

const muiButton: MuiButton = {
  styleOverrides: {
    sizeLarge: {
      fontSize: "16px",
      lineHeight: "26px",
    },
    outlined: {
      border: `1px solid ${ciCustomColors.blue[50]}`,
      padding: "8px 22px",
      fontSize: "0.925rem",
      fontWeight: 500,
      lineHeight: "26px",
    },
    root: {
      textTransform: "unset",
    },
  },
};

export default muiButton;
